module.exports = __webpack_public_path__ + "img/benefits-2.9d1d931d.svg";